<mat-card class="agency-card">
    <section class="data-table">
        <mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            @for (column of displayedColumns; track column) {
            <ng-container [matColumnDef]="column">
                <mat-header-cell *matHeaderCellDef> {{ columnNames[column] }} </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element[column]}} </mat-cell>
            </ng-container>
            }

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: 'true';"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
    </section>
</mat-card>